import { render } from "./WarehouseDamageDetailView.vue?vue&type=template&id=4e9f4846&scoped=true&ts=true"
import script from "./WarehouseDamageDetailView.vue?vue&type=script&lang=ts"
export * from "./WarehouseDamageDetailView.vue?vue&type=script&lang=ts"

import "./WarehouseDamageDetailView.vue?vue&type=style&index=0&id=4e9f4846&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9f4846"]])

export default __exports__